import { Injectable } from '@angular/core';
import { IS1SearchParams, IS1TypedPaginatedResult, S1ApiCrudService, S1HttpClientService } from '@app/s1';
import { IPista } from '../models/pista';
import { Observable } from 'rxjs';

export interface IRicercaPistaParams extends IS1SearchParams, Partial<IPista> { 
  idStazione?: string 
}

@Injectable({
  providedIn: 'root'
})
export class PistaService extends S1ApiCrudService<IPista, IRicercaPistaParams> {

  set idPath(newValue: string) {
    this.path = `/stazione/${newValue}/pista`;
  }

  constructor(s1HttpClient: S1HttpClientService) { 
    super(s1HttpClient, ""); // Path will be setted by set idPath
  }

  override ricerca(params: IRicercaPistaParams, path?: string): Observable<IS1TypedPaginatedResult<IPista>> {
    return super.ricerca(params, "/stazione/pista")
  }

}
